import {Component, contentChild, contentChildren, effect, input, output} from "@angular/core";
import {SharedModule} from "../../shared.module";
import {Translations} from "../../../../sim.translations.barrel";
import {ListItemComponent} from "@common/ui/list-item/list-item.component";
import {NewListItemComponent} from "@common/ui/list-item/new-list-item/new-list-item.component";
import {LabelledContainerComponent} from "@common/ui/labelled-container/labelled-container.component";
import {NgStyle, NgTemplateOutlet} from "@angular/common";
import {CdkDragDrop} from "@angular/cdk/drag-drop";

@Component({
	selector: "sim-list",
	imports: [SharedModule, LabelledContainerComponent, NgTemplateOutlet, NgStyle],
	templateUrl: "./list.component.html",
	styleUrl: "./list.component.scss",
})
export class ListComponent {
	// I/O
	public readonly label = input.required<string>();
	public readonly icon = input.required<string>();
	public readonly counter = input<number | null>(null);
	public readonly floatingLabel = input<boolean>(false);
	public readonly noBorder = input<boolean>(false);
	public readonly gap = input<string>("0.65rem");
	public readonly drop = output<CdkDragDrop<any>>();

	// Properties
	public items = contentChildren(ListItemComponent);
	public newItem = contentChild(NewListItemComponent);

	// Readonly
	protected readonly T = Translations;

	readonly #changeButtonVariant = effect(() => {
		const items = this.items();
		if (items) {
			this.newItem()?.buttonVariant.set(items.length > 0 ? "secondary" : "primary");
		}
	});
}
